import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function SubItemMenuAlumno({
  vTexto = "Item",
  vIcon = "fi fi-rr-pig",
  vNombreFrame = "h",
}) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [vFrame, setvFrame] = useState(searchParams.get("f"));

  useEffect(() => {
    setvFrame(searchParams.get("f"));
    console.log("Render SubItemMenuAlumno", searchParams.get("f"));
  }, [searchParams]);

  return (
    <div
      data-figma-id="4460:19127"
      class={`${
        vNombreFrame === vFrame ? "seleccionado-" : ""
      }item-menu-panel-admin`}
      onClick={() => {
        console.log("click", vNombreFrame);
        navigate(`?f=${vNombreFrame}`, { replace: true });
      }}
    >
      <div data-figma-id="4460:19164" class="home">
        <i class={`${vIcon} img-60`}></i>
      </div>
      <p data-figma-id="4460:19129" class="item-menu-texto-panel-admin">
        {vTexto}
      </p>
    </div>
  );
}
